import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { APIGoogleDrive } from "../../../../api";
import { G_DRIVE_API_URLS } from "../../../../api/googleDrive";
import { UploadedFilesList } from "../index";
import { fundedTraderFilesActions } from "../../../../reducers/fundedTraderFiles";
import DropZone from "../DropZone";

const UploadFilesGoogleDrive = (): React.ReactElement => {
  const params: { id: string } = useParams();
  const id = +params.id;
  const dispatch = useDispatch();
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const { isError, error } = useQuery({
    queryKey: [G_DRIVE_API_URLS.getCustomerFiles, id],
    queryFn: async () => {
      dispatch(fundedTraderFilesActions.fetchFilesRequest());
      const response = await APIGoogleDrive.getCustomerFiles(id);
      dispatch(fundedTraderFilesActions.fetchFilesSuccess(response.data));
      return response;
    },
    enabled: isOpenDialog,
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(fundedTraderFilesActions.fetchFilesFailed());
      console.error("error", error);
    }
  }, [isError, error]);

  const handleOpenDialog = () => setIsOpenDialog(true);
  const handleCloseDialog = () => setIsOpenDialog(false);

  return (
    <div>
      <Button onClick={handleOpenDialog}>Upload Files</Button>

      <Dialog fullWidth open={isOpenDialog} onClose={handleCloseDialog}>
        <DialogTitle>Upload files</DialogTitle>
        <DialogContent>
          <DropZone />
          <UploadedFilesList />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleCloseDialog}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UploadFilesGoogleDrive;
